import config from "config/config";

const bgUrl = {
  base: "none",
  md: `url(${config.staticUrl}/i/airhelp-plus/ahplus-landing-page-bg-fragment-triangles-02.svg)`,
};

export { bgUrl };
